"use client";

import React from "react";
import { Text, Price, Link } from "@pamperedchef/design-system";
import * as styles from "./AddToCartSliderContent.module.scss";

export interface AddedProductSnapshot {
	sku: string;
	quantity: number;
	name: string;
	imageUrl: string;
	listPrice: number;
	salePrice: number;
}

export interface AddToCartSliderContentProps {
	addedProduct: AddedProductSnapshot;
	locale?: string;
	currency?: string;
}

export function AddToCartSliderContent({
	addedProduct,
	locale = "en-US",
	currency = "USD"
}: AddToCartSliderContentProps): JSX.Element {
	const { sku, quantity, name, imageUrl, listPrice, salePrice } =
		addedProduct;
	const isSale = salePrice < listPrice;

	return (
		<div
			className={styles.container}
			data-component="AddToCartSliderContent"
		>
			{/* Product Card Section */}
			<div className={styles.productSection}>
				<div className={styles.card}>
					<div className={styles.imageWrap}>
						{imageUrl ? (
							// eslint-disable-next-line @next/next/no-img-element
							<img
								src={imageUrl}
								alt={name}
								className={styles.image}
							/>
						) : (
							<div className={styles.imagePlaceholder}>
								No Image
							</div>
						)}
					</div>
					<div className={styles.details}>
						<Link
							href={`/shop/${sku}`}
							kind="tertiary"
							size="sm"
							className={styles.name}
						>
							{name}
						</Link>
						<Text tag="p" styledAs="smr" className={styles.qty}>
							Quantity: {quantity}
						</Text>
						<div className={styles.pricing}>
							<Price
								display={salePrice}
								strikeThrough={isSale ? listPrice : undefined}
								locale={locale}
								currency={currency}
							/>
						</div>
					</div>
				</div>
				<div className={styles.divider} />
			</div>
		</div>
	);
}
